import store from "@/store";

export default {
    currentStep({ state, commit }, title) {
        state.steppers.forEach((step, index) => {
            if (step.title === title) {
                commit("CURRENT_STEP", { value: true, index: index });
            } else {
                commit("CURRENT_STEP", { value: false, index: index });
            }
        });
    },

    currentStepVotreProject({ state, commit }, title) {
        state.votreProjectSteepers.forEach((step, index) => {
            if (step.title === title) {
                commit("CURRENT_STEP_VOTRE_PROJECT", {
                    value: true,
                    index: index
                });
            } else {
                commit("CURRENT_STEP_VOTRE_PROJECT", {
                    value: false,
                    index: index
                });
            }
        });
    },

    completStep({ state, commit }, title) {
        state.votreProjectSteepers.forEach((step, index) => {
            if (step.title === title)
                commit("COMPLET_STEP_VOTRE_PROJECT", {
                    value: true,
                    index: index
                });
        });
    },

    showSection({ commit, getters, rootGetters }, title) {
        getters.getSteps.forEach((step, index) => {
            if (step.title === title) {
                if (rootGetters["user/isSimplifiedVersion"]) {
                    commit("SHOW_CURENT_SV_SECTION", {
                        value: true,
                        index: index
                    });
                } else {
                    commit("SHOW_CURENT_SECTION", {
                        value: true,
                        index: index
                    });
                }
            } else {
                if (rootGetters["user/isSimplifiedVersion"]) {
                    commit("SHOW_CURENT_SV_SECTION", {
                        value: false,
                        index: index
                    });
                } else {
                    commit("SHOW_CURENT_SECTION", {
                        value: false,
                        index: index
                    });
                }
            }
        });
    },

    stepFocus({ commit, getters, rootGetters }, title) {
        getters.getSteps.forEach((step, index) => {
            step.subSteps.forEach((substep, subIndex) => {
                if (substep.title === title) {
                    if (rootGetters["user/isSimplifiedVersion"]) {
                        commit("FOCUS_CURRENT_SV_STEP", {
                            value: true,
                            index: index,
                            subIndex: subIndex
                        });
                    } else {
                        commit("FOCUS_CURRENT_STEP", {
                            value: true,
                            index: index,
                            subIndex: subIndex
                        });
                    }
                } else {
                    if (rootGetters["user/isSimplifiedVersion"]) {
                        commit("FOCUS_CURRENT_SV_STEP", {
                            value: false,
                            index: index,
                            subIndex: subIndex
                        });
                    } else {
                        commit("FOCUS_CURRENT_STEP", {
                            value: false,
                            index: index,
                            subIndex: subIndex
                        });
                    }
                }
            });
        });
    },
    subStepComplete({ commit, getters, rootGetters }, title) {
        getters.getSteps.forEach((step, index) => {
            step.subSteps.forEach((subStep, subIndex) => {
                if (subStep.title === title)
                    if (rootGetters["user/isSimplifiedVersion"]) {
                        commit("SUB_SV_STEP_COMPLETED", {
                            index: index,
                            subIndex: subIndex
                        });
                    } else {
                        commit("SUB_STEP_COMPLETED", {
                            index: index,
                            subIndex: subIndex
                        });
                    }
            });
        });
    },
    completeBigStep({ commit, getters, rootGetters }, title) {
        getters.getSteps.forEach((step, index) => {
            if (step.title === title) {
                if (rootGetters["user/isSimplifiedVersion"]) {
                    commit("BIG_SV_STEP_COMPLETED", index);
                } else {
                    commit("BIG_STEP_COMPLETED", index);
                }
            }
        });
    },

    initSideBar(
        { state, commit, getters, rootGetters },
        { title, steeperTitle }
    ) {
        let lock = false;
        let path;
        getters.getSteps.forEach((step, index) => {
            step.subSteps.forEach((subStep, subIndex) => {
                if (title === subStep.title) {
                    lock = true;
                    if (subStep.title === "Votre projet") {
                        state.votreProjectSteepers.forEach(steeper => {
                            if (steeper.title === steeperTitle)
                                path = steeper.path;
                        });
                    } else if (subStep.title === "Moyens d’exploitation") {
                        state.steppers.forEach(steeper => {
                            if (steeper.title === steeperTitle)
                                path = steeper.path;
                        });
                    } else {
                        path = subStep.pathName;
                    }
                }
                if (!lock) {
                    if (subStep.title === "Votre projet") {
                        state.votreProjectSteepers.forEach(
                            (steeper, steeperIndex) => {
                                if (steeper.title !== steeperTitle)
                                    commit("COMPLET_STEP_VOTRE_PROJECT", {
                                        value: true,
                                        index: steeperIndex
                                    });
                            }
                        );
                    }
                    if (rootGetters["user/isSimplifiedVersion"]) {
                        commit("SUB_SV_STEP_COMPLETED", {
                            index: index,
                            subIndex: subIndex
                        });
                    } else {
                        commit("SUB_STEP_COMPLETED", {
                            index: index,
                            subIndex: subIndex
                        });
                    }
                } else {
                    if (rootGetters["user/isSimplifiedVersion"]) {
                        commit("FOCUS_CURRENT_SV_STEP", {
                            value: true,
                            index: index,
                            subIndex: subIndex
                        });
                    } else {
                        commit("FOCUS_CURRENT_STEP", {
                            value: true,
                            index: index,
                            subIndex: subIndex
                        });
                    }
                }
            });
            if (!lock) {
                if (rootGetters["user/isSimplifiedVersion"]) {
                    commit("BIG_SV_STEP_COMPLETED", index);
                } else {
                    commit("BIG_STEP_COMPLETED", index);
                }
            }
        });
        store.dispatch("user/setCurrentStep", path);
    },
    showSubStep({ commit, rootGetters }, index) {
        if (rootGetters["user/isSimplifiedVersion"]) {
            commit("SHOW_SUB_SV_STEPS", index);
        } else {
            commit("SHOW_SUB_STEPS", index);
        }
    }
};
